'use client'

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'
import { flushMeetingLeaves } from '@/lib/livekit/finalize-participant-leave'

// Remains mounted across dashboard navigation; retries only the signed-in
// user's departures on this tenant, including after a reload or reconnection.
export function MeetingAttendanceDelivery() {
  const { data: session } = useSession()
  const userId = session?.user?.id
  const tenantId = session?.user?.tenantId
  useEffect(() => {
    if (!userId || !tenantId) return
    const flush = () => { void flushMeetingLeaves({ userId, tenantId }) }
    flush()
    const timer = window.setInterval(flush, 10000)
    window.addEventListener('online', flush)
    window.addEventListener('pagehide', flush)
    return () => {
      window.clearInterval(timer)
      window.removeEventListener('online', flush)
      window.removeEventListener('pagehide', flush)
    }
  }, [userId, tenantId])
  return null
}
